const publicUrl = process.env.PUBLIC_URL || '';

/**
 * Hero background mode: 'video' or 'image'.
 * Override: REACT_APP_HERO_MODE=image
 */
export const HERO = {
  mode: (process.env.REACT_APP_HERO_MODE || 'video').toLowerCase() === 'image' ? 'image' : 'video',
  video: {
    desktop: `${publicUrl}/Videos/hero-desktop.mp4`,
    mobile: `${publicUrl}/Videos/hero-mobile.mp4`,
    /** Legacy fallback if desktop file not yet renamed */
    legacy: `${publicUrl}/Videos/hero-video.mp4`,
    poster: `${publicUrl}/videos/hero-poster.jpg`,
  },
  image: {
    desktop: process.env.REACT_APP_HERO_IMAGE_DESKTOP || `${publicUrl}/images/hero-desktop.png`,
    mobile: process.env.REACT_APP_HERO_IMAGE_MOBILE || `${publicUrl}/images/hero-mobile.png`,
    fallback: `${publicUrl}/images/hero.png`,
    alt: 'Atithi Travel & Taxi Service',
  },
};
